import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateCommunicationPreferences, getLoginUserDetail } from "../../../../redux/modules/profile/profile.action";
import { Link } from "react-router-dom";

const buildPreferences = (employeeDTO = {}) => ({
  isSmsCommunicationEnabled: employeeDTO.isSmsCommunicationEnabled !== false,
  isPushCommunicationEnabled: employeeDTO.isPushCommunicationEnabled !== false,
  isWhatsappCommunicationEnabled: employeeDTO.isWhatsappCommunicationEnabled !== false,
  isPhoneCommunicationEnabled: employeeDTO.isPhoneCommunicationEnabled !== false,
  // Fotoğraf paylaşımı KVKK opt-in: yalnızca açıkça onaylandıysa true.
  isPhotoSharingEnabled: employeeDTO.isPhotoSharingEnabled === true,
});

const CommunicationPreferences = () => {
  const dispatch = useDispatch();
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const employeeDTO = profileDetail?.employeeDTO || {};

  // preferences = ekrandaki güncel hali, savedPreferences = en son kaydedilmiş hali
  const [preferences, setPreferences] = useState(() => buildPreferences());
  const [savedPreferences, setSavedPreferences] = useState(() => buildPreferences());
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const next = buildPreferences(employeeDTO);
    setPreferences(next);
    setSavedPreferences(next);
  }, [employeeDTO]);

  // Sadece yerel state güncellenir; kayıt "Kaydet" düğmesiyle yapılır
  const handleChange = (name) => (e) => {
    const newValue = e.target.checked;
    setPreferences((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // Kullanıcı değişiklik yaptı mı? (geri tuşuna basılırsa kayıt yapılmaz)
  const isDirty = Object.keys(preferences).some(
    (key) => preferences[key] !== savedPreferences[key]
  );

  const handleReset = () => {
    setPreferences(savedPreferences);
  };

  const handleSave = async () => {
    if (!isDirty || isSaving) return;

    setIsSaving(true);
    try {
      const res = await dispatch(updateCommunicationPreferences(preferences));
      if (res && res.data) {
        await dispatch(getLoginUserDetail());
      }
      setSavedPreferences(preferences);
      toast.success("İletişim tercihleriniz kaydedildi.");
    } catch (error) {
      toast.error("İletişim tercihleriniz kaydedilemedi. Lütfen tekrar deneyin.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body p-4 p-md-5">
        <h5 className="card-title fw-bold mb-4">İletişim Tercihlerim</h5>
        <p className="text-muted mb-4">
          <Link to="/profile/information-text" target="_blank" className="text-decoration-none text-primary">Bilgilendirme metni</Link> kapsamında önemli kampanyalardan haberdar olmak için tercih ettiğiniz yöntemleri belirtebilirsiniz.
        </p>

        <div className="list-group list-group-flush rounded-3 border">
          <div className="list-group-item d-flex justify-content-between align-items-center p-4">
            <div>
              <h6 className="mb-1 fw-bold">SMS</h6>
              <small className="text-muted">Cep telefonunuza kısa mesaj yoluyla gönderilecek bildirimler</small>
            </div>
            <div className="form-check form-switch ms-3" style={{ transform: "scale(1.2)" }}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="smsSwitch"
                checked={preferences.isSmsCommunicationEnabled}
                onChange={handleChange("isSmsCommunicationEnabled")}
                style={{ cursor: "pointer", backgroundColor: preferences.isSmsCommunicationEnabled ? '#4CAF50' : '' , borderColor: preferences.isSmsCommunicationEnabled ? '#4CAF50' : '' }}
              />
            </div>
          </div>

          <div className="list-group-item d-flex justify-content-between align-items-center p-4">
            <div>
              <h6 className="mb-1 fw-bold">Push bildirim</h6>
              <small className="text-muted">Mobil uygulama üzerinden gönderilecek anlık bildirimler</small>
            </div>
            <div className="form-check form-switch ms-3" style={{ transform: "scale(1.2)" }}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="pushSwitch"
                checked={preferences.isPushCommunicationEnabled}
                onChange={handleChange("isPushCommunicationEnabled")}
                style={{ cursor: "pointer", backgroundColor: preferences.isPushCommunicationEnabled ? '#4CAF50' : '' , borderColor: preferences.isPushCommunicationEnabled ? '#4CAF50' : '' }}
              />
            </div>
          </div>

          <div className="list-group-item d-flex justify-content-between align-items-center p-4">
            <div>
              <h6 className="mb-1 fw-bold">WhatsApp</h6>
              <small className="text-muted">WhatsApp Business hattı üzerinden gönderilecek mesajlar</small>
            </div>
            <div className="form-check form-switch ms-3" style={{ transform: "scale(1.2)" }}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="whatsappSwitch"
                checked={preferences.isWhatsappCommunicationEnabled}
                onChange={handleChange("isWhatsappCommunicationEnabled")}
                style={{ cursor: "pointer", backgroundColor: preferences.isWhatsappCommunicationEnabled ? '#4CAF50' : '' , borderColor: preferences.isWhatsappCommunicationEnabled ? '#4CAF50' : '' }}
              />
            </div>
          </div>

          <div className="list-group-item d-flex justify-content-between align-items-center p-4">
            <div>
              <h6 className="mb-1 fw-bold">Telefon araması</h6>
              <small className="text-muted">Çağrı merkezi tarafından cep telefonunuza yapılacak aramalar</small>
            </div>
            <div className="form-check form-switch ms-3" style={{ transform: "scale(1.2)" }}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="phoneSwitch"
                checked={preferences.isPhoneCommunicationEnabled}
                onChange={handleChange("isPhoneCommunicationEnabled")}
                style={{ cursor: "pointer", backgroundColor: preferences.isPhoneCommunicationEnabled ? '#4CAF50' : '' , borderColor: preferences.isPhoneCommunicationEnabled ? '#4CAF50' : '' }}
              />
            </div>
          </div>

          <div className="list-group-item d-flex justify-content-between align-items-center p-4">
            <div>
              <h6 className="mb-1 fw-bold">Fotoğraf Yükleme</h6>
              <small className="text-muted">
                Yüklediğim fotoğrafların Cargill Gurme Club portalında yayımlanmasına ve bu kapsamda işlenmesine onay veriyorum.
              </small>
            </div>
            <div className="form-check form-switch ms-3" style={{ transform: "scale(1.2)" }}>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="photoSharingSwitch"
                checked={preferences.isPhotoSharingEnabled}
                onChange={handleChange("isPhotoSharingEnabled")}
                style={{ cursor: "pointer", backgroundColor: preferences.isPhotoSharingEnabled ? '#4CAF50' : '' , borderColor: preferences.isPhotoSharingEnabled ? '#4CAF50' : '' }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end align-items-center gap-2 mt-4">
          {!isDirty && !isSaving && (
            <small className="text-muted me-auto">
              Henüz bir değişiklik yapmadınız.
            </small>
          )}
          <span
            className="d-inline-block"
            title={!isDirty ? "Henüz bir değişiklik yapmadınız." : ""}
          >
            <button
              type="button"
              className="btn btn-outline-secondary px-4"
              onClick={handleReset}
              disabled={!isDirty || isSaving}
              style={!isDirty || isSaving ? { pointerEvents: "none" } : undefined}
            >
              Vazgeç
            </button>
          </span>
          <span
            className="d-inline-block"
            title={!isDirty ? "Henüz bir değişiklik yapmadınız." : ""}
          >
            <button
              type="button"
              className="btn btn-blue px-4"
              onClick={handleSave}
              disabled={!isDirty || isSaving}
              style={!isDirty || isSaving ? { pointerEvents: "none" } : undefined}
            >
              {isSaving ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

export default CommunicationPreferences;
